/** Erreur HTTP normalisée (statut + code + message + payload brut). */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly payload: unknown;

  constructor(status: number, code: string, message: string, payload: unknown = undefined) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.payload = payload;
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}

const DEFAULT_MESSAGES: Record<number, string> = {
  400: 'Requête invalide.',
  401: 'Non autorisé : identifiants invalides ou session expirée.',
  403: 'Accès refusé.',
  404: 'Ressource introuvable.',
  500: 'Erreur interne du serveur.',
  503: 'Service indisponible, réessayez plus tard.',
};

export function httpErrorMessage(error: unknown): string {
  if (isApiError(error)) return error.message;
  if (error instanceof Error && error.message) return error.message;
  return 'Une erreur inattendue est survenue.';
}

export function defaultMessageForStatus(status: number): string {
  return DEFAULT_MESSAGES[status] ?? 'Une erreur inattendue est survenue.';
}
